<template>
  <BaseModal
    :model-value="modelValue"
    :title="$t('home.feedback.title')"
    hide-footer
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <p class="feedback-modal-intro">{{ $t("home.feedback.description") }}</p>
    <div class="feedback-modal-form">
      <FeedbackForm />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/Modal.vue";
import FeedbackForm from "@/components/FeedbackForm.vue";

// The landing page used to devote a full section to the feedback form. It is a
// support channel, not a conversion step, so it moved behind a footer link;
// the modal is the host that keeps the form reachable from every marketing
// page the footer renders on.
export default {
  name: "FeedbackModal",
  components: { BaseModal, FeedbackForm },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.feedback-modal-intro {
  color: var(--al-text-muted);
  font-size: 16px;
  line-height: 1.55;
  margin: 0 0 12px;
}

/* FeedbackForm ships its own white card chrome for standalone use; strip it
   inside the modal so it sits flush in the dialog body instead of drawing a
   second card inside one. Same precedent as AccountView's embed
   (.contact-section :deep(.feedback-form)). */
.feedback-modal-form :deep(.feedback-form) {
  max-width: none;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  margin-bottom: 0;
}
</style>
